<div class="section">
  <div class="title" i18n="roles title|Roles title into profile page@@rolesTitleProfilePage">
    Groups and permissions
  </div>
  <div class="content">
    <div class="col">
      <div class="text title">
        <div
          class="text title"
          i18n="groups subtitle|Groups subtitle into profile page@@groupsSubtitleProfilePage"
        >
          My groups
        </div>
        <span class="text" *ngIf="isEditable()">
          <span
            class="text mark-down"
            role="button"
            tabindex="0"
            (click)="openAddandRemoveUserWizard('fusion_sso_add_user_to_groups')"
            i18n="add button|Add button into profile page@@addButtonProfilePage"
            >add</span
          >
          <span
            class="text mark-down"
            role="button"
            tabindex="0"
            (click)="openAddandRemoveUserWizard('fusion_sso_remove_user_from_group')"
            i18n="remove button|Remove button into profile page@@removeButtonProfilePage"
            >remove</span
          >
        </span>
      </div>
      <span class="text readonly content" *ngFor="let group of userInfo.groups">{{
        group.name
      }}</span>
    </div>
    <div class="col">
      <div class="text title">
        <div
          class="text title"
          i18n="roles subtitle|Roles subtitle into profile page@@rolesSubtitleProfilePage"
        >
          My permissions
        </div>
      </div>
      <span class="text readonly content" *ngFor="let role of userInfo.effectiveRoles">{{
        getRoleFriendlyName(role.name)
      }}</span>
      <span class="text readonly content" *ngIf="userInfo?.effectiveRoles?.length === 0">{{
        getRoleFriendlyName(defaultRoleId)
      }}</span>
    </div>
  </div>
</div>
